// Deployment overrides are keyed by hostname; account overrides by company id.
// Unknown partners deliberately receive a neutral identity, never Monger support.
export const helpBrands = {
  hosts: {
    "app.monger.tech": {
      name: "MongerTracker",
      logo: "/static/logo.png",
      color: "#1565c0",
      supportUrl:
        "https://support.au.monger.tech/servicedesk/customer/portal/1",
    },
    "monger-tracker.web.app": {
      name: "MongerTracker",
      logo: "/static/logo.png",
      color: "#1565c0",
      supportUrl:
        "https://support.au.monger.tech/servicedesk/customer/portal/1",
    },
  },
  companies: {
    112: {
      name: "Yes Energy",
      logo: "/static/YesEnergyLogo.png",
      color: "#1565c0",
    },
  },
};
export function safeUrl(value, allowMail = false) {
  return typeof value === "string" &&
    (/^\/(?!\/)/.test(value) ||
      /^https:\/\//.test(value) ||
      (allowMail && /^mailto:[^\s]+@[^\s]+$/.test(value)))
    ? value
    : undefined;
}
export function resolveHelpBrand(
  user,
  hostname = window.location.hostname,
  brands = helpBrands
) {
  const brand =
    brands.companies[String(user?.companyid)] || brands.hosts[hostname] || {};
  return {
    name: brand.name || "Platform",
    logo: safeUrl(brand.logo),
    color: /^#[\da-f]{6}$/i.test(brand.color || "") ? brand.color : "#286b64",
    supportUrl: safeUrl(brand.supportUrl, true),
  };
}
